import {Directive, HostListener, input, output} from "@angular/core";

@Directive({
    selector: '[copy-clipboard]',
    standalone: false
})
export class CopyClipboardDirective {

    public readonly payload = input<string>(undefined, { alias: "copy-clipboard" });

    public readonly copied = output<string>({ alias: 'copied' });

    @HostListener("click", ["$event"])
    public onClick(event: MouseEvent): void {

        event.preventDefault();
        if (!this.payload())
            return;

        let listener = (e: ClipboardEvent) => {
            let clipboard = e.clipboardData || window["clipboardData"];
            const payload = this.payload();
            clipboard.setData("text", payload.toString());
            e.preventDefault();

            this.copied.emit(payload);
        };

        document.addEventListener("copy", listener, false)
        document.execCommand("copy");
        document.removeEventListener("copy", listener, false);
    }

    public static copyToClipboard(textToCopy) {
        let listener = (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (textToCopy));
            e.preventDefault();
        };

        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
    }
}
